import { makeStyles, tokens } from '@coreai/fluentui-react';

export const useStyles = makeStyles({
  wrapper: {
    position: 'relative',
  },
  skippedWrapper: {
    position: 'relative',
    opacity: 0.5,
  },
  // Step count badge — lives on the outer wrapper rather than inside the
  // icon slot so it isn't clipped by the icon circle's overflow:hidden.
  // The wrapper width matches FloatingNode's 56px iconBox, so these offsets
  // anchor the 18px badge half-on / half-off the circle's bottom-right rim.
  countBadge: {
    position: 'absolute',
    top: '38px',
    right: '-4px',
    minWidth: '18px',
    height: '18px',
    borderRadius: tokens.borderRadiusCircular,
    backgroundColor: tokens.colorPaletteGreenBackground2,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightBold,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: tokens.spacingHorizontalXS,
    paddingRight: tokens.spacingHorizontalXS,
    zIndex: 2,
    boxShadow: tokens.shadow4,
    border: `1.5px solid ${tokens.colorNeutralBackground1}`,
    pointerEvents: 'none',
  },
  // Clickable chevron prefix inline with label — enlarged hit area
  chevronPrefix: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: tokens.colorNeutralForeground2,
    flexShrink: 0,
    padding: tokens.spacingVerticalSNudge,
    margin: `-${tokens.spacingVerticalSNudge}`,
    borderRadius: tokens.borderRadiusSmall,
    ':hover': {
      color: tokens.colorNeutralForeground1,
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  chevronIcon: {
    transitionProperty: 'transform',
    transitionDuration: tokens.durationNormal,
    transitionTimingFunction: tokens.curveEasyEase,
  },
  chevronIconExpanded: {
    transform: 'rotate(90deg)',
  },
});
